// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import InputField from '../../../customFields/InputField';
import SelectField from '../../../customFields/SelectField';

const VariablePaySection = ({
  basicType,
  variableType,
  quantity,
  variablePayAfter,
  maxQuantity,
  change,
  reduxFormName = 'createWorkOrderReduxForm',
  enableEmptyValue,
}) => {
  useEffect(() => {
    if (
      (variableType === basicType) || ((variableType === 'Hour') && (basicType === 'Site'))
      && (variablePayAfter !== quantity)
    ) {
      change(reduxFormName, 'variablePayAfter', quantity);
    }
  }, [basicType, variableType, quantity]);

  useEffect(() => {
    if (+variablePayAfter > +maxQuantity) {
      change(reduxFormName, 'maxQuantity', variablePayAfter || 0);
    }
  }, [variablePayAfter]);

  return (

    <>
    <div className="group_col">
        <div className="group_name">Variable Pay (Optional)</div>
        <div className="small_row">
          <div className="field_name">
            <label htmlFor="amount2">Amount*</label>
          </div>
          <div className="field_block">
          <Field
              name="variableAmount"
              component={InputField}
              type="number"
              placeholder="$0.00"
              inputClassName="form-control small-styled-input"
              min={0.00}
            />
          </div>
        </div>
        <div className="small_row">
          <div className="field_name">
            <label htmlFor="per2">Per*</label>
          </div>
          <div className="field_block">
          <Field
              name="variableType"
              component={SelectField}
              className="padding-bottom-10 padding-left-12-5"
              inputClassName="browser-default custom-select per"
              enableEmptyValue={enableEmptyValue}
              options={[
                {
                  value: 'Hour',
                  label: 'Hour',
                },
                {
                  value: 'Device',
                  label: 'Device',
                },
              ]}
            />
            {/* <span className="step_btns">
              <span className="icon_stepup"></span>
              <span className="icon_stepdown"></span>
            </span> */}
          </div>
        </div>
        <div className="small_row">
          <div className="field_name">
            <label htmlFor="after">After</label>
          </div>
          <div className="field_block">
          <Field
              name="variablePayAfter"
              component={InputField}
              type="number"
              placeholder="00"
              inputClassName="form-control small-styled-input"
              disabled={(variableType === basicType) || ((variableType === 'Hour') && (basicType === 'Site'))}
              min={0}
            />
          </div>
        </div>
        <div className="small_row">
          <div className="field_name">
            <label htmlFor="max_qty">Max Qty*</label>
          </div>
          <div className="field_block">
          <Field
              name="maxQuantity"
              component={InputField}
              type="number"
              placeholder="00"
              inputClassName="form-control small-styled-input"
              min={variablePayAfter || 0}
            />
          </div>
        </div>
      </div>
    
    </>
  );
};

export default VariablePaySection;
